/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2022-01-18 11:22:59
 *
 *******************************************************/
// @flow

export const ADD_OPTION_EMAIL_REQUEST = 'ADD_OPTION_EMAIL_REQUEST';
type ADD_OPTION_EMAIL_REQUEST_TYPE = 'ADD_OPTION_EMAIL_REQUEST';

export const ADD_OPTION_EMAIL_SUCCESS = 'ADD_OPTION_EMAIL_SUCCESS';
type ADD_OPTION_EMAIL_SUCCESS_TYPE = 'ADD_OPTION_EMAIL_SUCCESS';

export const ADD_OPTION_EMAIL_FAILURE = 'ADD_OPTION_EMAIL_FAILURE';
type ADD_OPTION_EMAIL_FAILURE_TYPE = 'ADD_OPTION_EMAIL_FAILURE';

type AddOptionEmailSuccess = {
  data: Object
};

type AddOptionEmailFailure = {
  error: any
};

type AddOptionEmailRequestAction = Action<ADD_OPTION_EMAIL_REQUEST_TYPE, null>;

type AddOptionEmailSuccessAction = Action<ADD_OPTION_EMAIL_SUCCESS_TYPE, AddOptionEmailSuccess>;

type AddOptionEmailFailureAction = Action<ADD_OPTION_EMAIL_FAILURE_TYPE, AddOptionEmailFailure>;

type OptionEmailInfoType = {
  id: number,
  tenantId: string,
  status: string,
  optEmail: string
};

export type AddOptionEmailState = {
  loading: boolean,
  success: boolean,
  error: any,
  data: Array<OptionEmailInfoType>
};

export type AddOptionEmailAction =
  | AddOptionEmailRequestAction
  | AddOptionEmailSuccessAction
  | AddOptionEmailFailureAction;
